import React, { Fragment, useEffect, useState } from 'react';
import { BOTTOM_INDENTS } from '@constants';
import { useStore } from '@hooks';
import { Loader, Typography } from '@ui';
import { observer } from 'mobx-react';
import StaffAccounts from './components/StaffAccounts';
import StoreOwner from './components/StoreOwner';

const TeamManagement = observer(() => {
    const store = useStore();
    const [loading, setLoading] = useState(true);
    const { getTeamMembers, staffAccounts } = store.accountsStore;

    useEffect(() => {
        (async () => {
            await getTeamMembers();
            setLoading(false);
        })();
    }, []);

    if (loading) {
        return <Loader />;
    }

    return (
        <Fragment>
            <Typography.Title level={2} style={BOTTOM_INDENTS.M} data-e2e='team-management_page_title'>
                Team Management
            </Typography.Title>
            <StoreOwner />
            <StaffAccounts staffAccounts={staffAccounts} />
        </Fragment>
    );
});

export default TeamManagement;
